import React, { useEffect } from 'react';
import styled from 'styled-components';
import { useStore } from '../../../context/appContext';

// assets
import BankLogo from '../../../assets/img/BankLogo.png';
import getVerifySecurity from '../../../apis/getVerifySecurity';

const ImgDiv = styled.div`
  grid-area: content;
  display: inline-grid;
  justify-items: center;
  align-items: center;
`;

const Img = styled.img`
  width: 100%;
`;

function Initial() {
  const { stepForward, setOperationData, setError, stepTwoForward, notificate, setLoading } = useStore();

  useEffect(()=>{
    verifySecurityData()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  },[])

  const verifySecurityData = async () => {
    setLoading(true);

    const response = await getVerifySecurity(setOperationData, setError);

    notificate.operationId = response && response.operationId;
    if (response) {
      if (response.security) {
        stepForward();
        setLoading(false);
        return
      } else {
        stepTwoForward();
        setLoading(false);
      }
    };

  };

  return (
    <>
      <ImgDiv>
        <Img src={BankLogo} />
      </ImgDiv>
    </>
  );
}

export default Initial;
